import { render, staticRenderFns } from "./StashboardSettings.vue?vue&type=template&id=376a70dc&scoped=true&"
import script from "./StashboardSettings.vue?vue&type=script&lang=js&"
export * from "./StashboardSettings.vue?vue&type=script&lang=js&"
import style0 from "./StashboardSettings.vue?vue&type=style&index=0&id=376a70dc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "376a70dc",
  null
  
)

export default component.exports